import axios from 'axios';

export const askToChatBot = (question: string, locationId: string, onSuccess: (message: string) => void, onFailure: (error: string) => void) => {
  return async () => {
    await axios
      .get('/openai-chatbot/ask-admin', {
        params: {
          question: question,
          locationId: locationId
        },
      })
      .then((response) => {
        if (response?.status === 200) {
          onSuccess(response?.data?.responseText);
        } else {
          onFailure(response?.data?.responseText)
        }
      })
      .catch((err) => onFailure(err?.response?.data?.responseText));
  };
};
